/**
 * Step Type: What type of step is this?
 */
export enum StepType {
  //Regular = 0,
  StartTask = 0,
  ArrivedToPickup = 10,
  TradePlateRecording = 11,
  ConfirmInsurance = 9,
  PickupPhoto = 1,
  PickupSignature = 2,
  DropOffPhoto = 3,
  DropOffSignature = 4,
  StartMovement = 5,
  EndMovement = 6,
  Rating = 7,
  CompleteTask = 8,
  CallByacarConfirmation = 12,

  //DashboardPhoto = 5,
  //General = 6
}
